'use strict';

angular.module('atex.dam').directive('damRichtextCk', [ '$timeout', function($timeout) {
  return {
    require : '?ngModel',

    link : function(scope, element, attr, ngModel) {
      var width = attr.ckEditorWidth ? attr.ckEditorWidth : $(element[0]).css('width');

      var ck;
      ck = CKEDITOR.replace(element[0], {
        width : width,
        height : $(element[0]).css('height')
      });

      ck.on('pasteState', function() {
        $timeout(function() {
          if (ngModel.$viewValue !== ck.getData()) {
            ngModel.$setViewValue(ck.getData());
          }
        });
      });

      ngModel.$render = function() {
        if (ngModel.$modelValue) {
          ck.setData(ngModel.$modelValue);
        }
      };

      scope.$on('$destroy', function() {
        // The blur event is not fired when out of scope, but is needed because
        // the word-count plugin is relying on it to stop counting words.
        ck.fire('blur');
        if (CKEDITOR.instances[attr.id]) {
          CKEDITOR.instances[attr.id].destroy(false);
        }
      });

    }

  };
} ]);
